import { API_BASE_URL } from "@/config";
import { handle_registration_redirect } from "@/utils/redirects";
import { asset_data_retrieval, anonymous_data_retrieval } from "@/utils/decoding";


export const LandingPageLogic = {
  data() {
    return {
      customer_application: null,
      client_admin_id: null,
      company_name: null,
      workflow_name: null,
      asset_id: null,
    };
  },
  async mounted() {
    const GET_CLIENT_ID = sessionStorage.getItem("client_admin_id");
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("user_id");

    // Process query parameters
    const { embedding_data, asset_data, customer_application, anonymous_data, existing_user } = this.$route.query;
    
    // Handle existing_user parameter - redirect to login
    if (existing_user === 'true') {
      // Clear any existing session data to ensure fresh login
      localStorage.removeItem('token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_state');
      sessionStorage.removeItem('is_anonymous_user');
      
      // Redirect to login page
      this.$router.push({ name: "user_login" });
      return;
    }
    
    if (anonymous_data) {
      localStorage.clear();
      sessionStorage.clear();
    }


    // Redirect if already logged in
    if (token && user_id && !anonymous_data) {
      await this.redirect(token, GET_CLIENT_ID);
      return; // Stop further execution in mounted if redirected
    }

    if (embedding_data) {
      this.get_client_id_on_session(embedding_data);
    }

    if (anonymous_data) {


      // Call the function to retrieve anonymous data
      var { user_token, user_pk, user_role, client_admin_id, user_workflow_id, error } = await anonymous_data_retrieval(anonymous_data);

      if (error) {
        this.$router.push({ name: "invalid_token" });
        return; // Stop further execution if there's an error
      }
      
      // Check if the response contains the required data
      sessionStorage.clear();
      localStorage.clear();
  
      localStorage.setItem('user_id', user_pk);
      this.$store.commit('set_user_role', user_role)
      
      localStorage.setItem('token', user_token);
      localStorage.setItem('user_state', 'logged_in');
      
      sessionStorage.setItem('client_admin_id', client_admin_id);
      this.$store.commit('set_workflow_id', user_workflow_id);

      sessionStorage.setItem('is_anonymous_user', true);
      // Redirect to the appropriate service
      this.fetch_current_service(user_workflow_id)
    }

    if (asset_data) {
      try {
        const { workflow_name, workflow_id, asset_id, user_id: clientUserId } = await asset_data_retrieval(asset_data);
        this.client_admin_id = clientUserId; // Assign to component data
        this.asset_id = asset_id;
        this.workflow_name = workflow_name;
        // Call the method to store asset workflow in session
        this.get_asset_workflow_on_session(
          clientUserId,
          asset_id,
          workflow_id,
          workflow_name
        );
      } catch (error) {
        console.error("Error retrieving asset data:", error);
        this.$router.push({ name: "invalid_link" }); // Or handle error appropriately
      }
    }

    if (customer_application) {
      this.customer_application = customer_application; // Assign to component data
      this.get_customer_application_on_session(customer_application);
    }
  },
  methods: {
    redirect(token, GET_CLIENT_ID) {
      const CHECK_PROCESS_URL = `${API_BASE_URL}/verify_api/system_management_api/user_redirect_api/`;

      $.ajax({
        url: CHECK_PROCESS_URL,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${token}`,
        },
        success: (response) => {
          // Assuming fetch_current_service is available via MAIN_CONTROLLER or globally
          handle_registration_redirect(
            response,
            this.$router,
            this.$store,
            this.fetch_current_service, // Make sure this method exists where needed
            GET_CLIENT_ID
          );
        },
        error: () => {
          let error_message = "There was an error while redirecting";
          // Use toast if available, otherwise log error
          if (this.showError) {
            this.showError(error_message);
          } else {
            console.error(error_message);
          }
        },
      });
    },

    showError(selector, message) {
      // Ensure jQuery is available
      if (typeof $ !== 'undefined') {
        $(selector).text(message).removeClass("d-none");
        setTimeout(() => {
          $(selector).addClass("d-none");
        }, 3000);
      } else {
        console.error("jQuery ($) is not defined. Cannot show error message.");
      }
    },

    // Default implementation using embedding_data
    get_client_id_on_session(embedding_data) {
      const BASE_URL = API_BASE_URL;
      // Default URL structure
      const GET_CLIENT_ID_URL = `${BASE_URL}/verify_api/${embedding_data}/`;

      $.ajax({
        method: "GET",
        url: GET_CLIENT_ID_URL,
        contentType: "application/json",
        success: (response) => {
          if (response.client_admin_id) {
            sessionStorage.clear();
            localStorage.clear();

            // Use component data properties directly
            this.client_admin_id = response.client_admin_id;
            this.company_name = response.company_name;

            sessionStorage.setItem("client_admin_id", this.client_admin_id);
            sessionStorage.setItem("company_name", this.company_name);

            this.$store.commit("client_admin_id", this.client_admin_id);
            this.$store.commit("company_name", this.company_name);

            this.$router.push({ name: "landing_page" });
          } else {
            this.$router.push({ name: "invalid_link" });
          }
        },
        error: () => {
          this.$router.push({ name: "invalid_link" });
        },
      });
    },

    get_asset_workflow_on_session(
      client_admin_id,
      asset_id,
      workflow_id,
      workflow_name
    ) {
      const BASE_URL = API_BASE_URL;
      const GET_ASSET_WORFLOW_URL = `${BASE_URL}/verify_api/${workflow_name}/${client_admin_id}/${workflow_id}/${asset_id}/`;
    
      $.ajax({
        method: "GET",
        url: GET_ASSET_WORFLOW_URL,
        contentType: "application/json",
        success: (response) => {
          const properties = ["client_admin_id", "asset_id", "workflow_id"];
    
          properties.forEach((prop) => {
            if (response[prop]) {
              sessionStorage.setItem(prop, response[prop]);
              this.$store.commit(prop, response[prop]);
            }
          });
    
          // Navigate after all properties are set
          this.$router.push({ name: "landing_page" });
        },
        error: (error) => {
          let error_message = "Getting asset workflow failed";
          if (error.responseJSON && error.responseJSON.error) {
            error_message = error.responseJSON.error;
          }
          this.showError(".error-message", error_message);
        },
      });
    },

    get_customer_application_on_session(customer_application) {
      const BASE_URL = API_BASE_URL;
      const GET_CUSTOMER_APPLICATION_URL = `${BASE_URL}/verify_api/${customer_application}/director_verification/`;

      $.ajax({
        method: "GET",
        url: GET_CUSTOMER_APPLICATION_URL,
        contentType: "application/json",
        success: (response) => {
          if (response.customer_application) {
            sessionStorage.setItem(
              "customer_application",
              response.customer_application
            );
            this.$store.commit(
              "customer_application",
              response.customer_application
            );
            this.$router.push({ name: "landing_page" });
          }
        },
        error: (error) => {
          let error_message = "Getting customer application failed";
          if (error.responseJSON && error.responseJSON.error) {
            error_message = error.responseJSON.error;
          }
          this.showError(".error-message", error_message);
        },
      });
    },

    next_to_register() {
      this.$router.push({ name: "user_registration" });
    },
  },
};
